import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Connect } from './SearchResultEnterpriseContainer';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { AddEntityWatcherButton } from '../../../../watchers/components/add-entity-watcher/AddEntityWatcherButton';
import { buildUrlWithParameters } from '../../../../utils/url-utils/urlUtils';
import { QueryParamsType } from '../../../state/reducers/queryParams.types';
import {
  SearchCard,
  FollowContainer,
  SearchCardTitle,
  SearchCardFooter,
} from '../results-card';
import { EnterpriseCardTitle } from '../../../../enterprise/components/card/EnterpriseCardTitle';
import {
  EntitiesList,
  EntitiesListItem,
} from '../../../../components/entities-card/EntitiesList';
import { AnimatedLink } from '../../../../components/animated-link/AnimatedLink';
import { UserContextType } from '../../../../user/user.types';
import { withUser } from '../../../../user/UserContext';

type Props = {
  enterprises: Array<any>;
  originalQueryKey: QueryParamsType['originalQueryKey'];
} & UserContextType &
  WithRestrictedModalProps;

const source = 'enterprise_search_result';

class RawSearchResultEnterprise extends React.Component<Props> {
  protectFeature = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    const { accessPremium, openRestrictedModal } = this.props;
    if (!accessPremium) {
      event.preventDefault();
      openRestrictedModal(source);
    }
  };

  render() {
    const {
      enterprises,
      openRestrictedModal,
      accessPremium,
      originalQueryKey,
    } = this.props;

    return (
      <>
        {enterprises.map(enterprise => (
          <SearchCard key={enterprise.enterpriseId}>
            <SearchCardTitle>
              <EnterpriseCardTitle
                onClick={this.protectFeature}
                href={
                  accessPremium
                    ? buildUrlWithParameters(enterprise.url, {
                        source,
                        original_query_key: originalQueryKey,
                      })
                    : ''
                }
              >
                {enterprise.raisonSociale}
              </EnterpriseCardTitle>
            </SearchCardTitle>
            <EntitiesList>
              {!!enterprise.appellationCommerciale && (
                <EntitiesListItem
                  left="Appellation commerciale"
                  right={enterprise.appellationCommerciale}
                />
              )}
              {!!enterprise.siren && (
                <EntitiesListItem left="SIREN" right={enterprise.siren} />
              )}
              {!!enterprise.ville && (
                <EntitiesListItem left="Ville" right={enterprise.ville} />
              )}
              {!!enterprise.secteurActivite && (
                <EntitiesListItem
                  left="Secteur d’activité"
                  right={enterprise.secteurActivite}
                />
              )}
              {!!enterprise.tailleGlob && (
                <EntitiesListItem left="Taille" right={enterprise.tailleGlob} />
              )}
              {!!enterprise.dateRadiation && (
                <EntitiesListItem
                  left="Date de radiation"
                  right={enterprise.dateRadiation}
                />
              )}
            </EntitiesList>

            <FollowContainer>
              <AddEntityWatcherButton
                queryParams={{
                  eid: enterprise.enterpriseId,
                  q: enterprise.raisonSociale,
                }}
                uniqueId={enterprise.enterpriseId}
                restrict={() => openRestrictedModal(source)}
                source={source}
                secondary
              />
            </FollowContainer>

            {!!enterprise.siren && (
              <SearchCardFooter>
                <AnimatedLink
                  href={buildUrlWithParameters('/search', {
                    q: enterprise.raisonSociale,
                    eid: enterprise.enterpriseId,
                    source,
                  })}
                >
                  <FormattedMessage id="search/components/search-results/enterprise/SearchResultEnterprise.tsx/1" />
                </AnimatedLink>
              </SearchCardFooter>
            )}
          </SearchCard>
        ))}
      </>
    );
  }
}

export const SearchResultEnterprise = withUser(
  withRestrictedModal(Connect(RawSearchResultEnterprise)),
);
